module.exports = __webpack_public_path__ + "assets/media/wordpress-logo.0efcecf0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/wordpress-logo.svg
// module id = 2895
// module chunks = 0